const SITE_UNAVAILABLE_URL = 'https://b2b-website-unavailable.ua-brands.workers.dev/';

const SiteUnavailable = () => {
    return (
        <section id="maincontent" className="login-area pt-6 pt-md-8 pb-9">
            <div className="container-fluid">
                <div className="row">
                    <div className="col col-md-6 mx-auto">
                        <iframe
                            title="Website temporarily unavailable"
                            src={SITE_UNAVAILABLE_URL}
                            style={{ width: '100%', minHeight: '360px', border: 0 }}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SiteUnavailable;
